import React from 'react';
import toast from 'react-hot-toast';
import useAuth from '../../../hooks/useAuth';
import { axiosInstance } from '../../../utils/axios';

export default function ReviewActions({ orderId, refresh }: { orderId: number; refresh: () => void }) {
  const { user } = useAuth();
  const [busy, setBusy] = React.useState(false);
  if (user?.role !== 'admin') return null;

  const resolve = async (remove: boolean) => {
    if (busy || (remove && !window.confirm('¿Eliminar esta venta en revisión?'))) return;
    setBusy(true);
    try {
      if (remove) await axiosInstance.delete(`/orders/delete-order/${orderId}`);
      else await axiosInstance.post(`/orders/accept-review/${orderId}`);
      toast.success(remove ? 'Venta eliminada' : 'Venta aceptada como borrador');
      refresh();
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'No se pudo resolver la venta');
      if ([404, 409].includes(error.response?.status)) refresh();
    } finally {
      setBusy(false);
    }
  };

  return <span className="d-inline-flex gap-1">
    <button type="button" className="btn btn-sm btn-success" disabled={busy} onClick={() => resolve(false)}>Aceptar</button>
    <button type="button" className="btn btn-sm btn-outline-danger" disabled={busy} onClick={() => resolve(true)}>Eliminar</button>
  </span>;
}
